import React from "react";
import './project.css'

export default function Project(){
    return(
        <div className="project_Container">
            <h1 className="project_Container_text">Projects</h1>
            <div className="projects">
                <div className="projects_col1">
                    <div className="projects_card">
                        <p>This Web Application itself is a project lol</p>
                        <p>No other finished projects yet</p>
                        <p>But something big is cooking</p>
                    </div>
                </div>
            </div>
        </div>
    )
}